import {h, Fragment} from "preact"
import { useAppStateSelector } from "@nosto/preact"
import { useState, useEffect } from "preact/hooks"
import Sidebar from "./Sidebar"
import ActionToolbar from "./ActionToolbar"
import { updatePageTitle } from '../helpers'

const isDesktop = () => typeof window !== 'undefined' && window.innerWidth >= 1024

function ContentWrapper({ type, children }) {
    const {
        countProducts,
        foundProducts,
        loading,
        pageType,
        query,
    } = useAppStateSelector(state => ({ 
        countProducts: state.response.products?.total || 0, 
        foundProducts: state.response.products?.total > 0, 
        loading: state.loading,
        pageType: state.pageType,
        query: state.query,
    }))

    const [gridColumns, setGridColumns] = useState(() => isDesktop() ? 3 : 2)
    const [isNewLayout, setIsNewLayout] = useState(false)

    useEffect(() => {
        if (typeof window !== 'undefined' && window.isNewLayout) {
            setIsNewLayout(true)
        }
    }, [])

    useEffect(() => {
        const handleGridChange = (e) => {
            setGridColumns(e.detail.columns)
        }

        window.addEventListener('gridColumnsChange', handleGridChange)
        
        return () => {
            window.removeEventListener('gridColumnsChange', handleGridChange)
        }
    }, [])

    if (pageType === 'search') {
        updatePageTitle(query.query, countProducts)
    }

    const containerClass = `ns-collection-page-container grid-view-${gridColumns}-col${
        isNewLayout ? ' new-layout' : ''
      }`;

    return (
        <>
            {pageType === 'search' ? (
                <div class="collection-hero color-scheme-1 gradient">
                    <div class="collection-hero__inner page-width">
                        <div class="collection-hero__text-wrapper">
                            {/* <h2 class="ss__title collection-hero__title ss__title--has-results mt-14 mb-0 lg:mt-20">
                                {foundProducts ? (
                                    <>Search results for "<span class="ss__query">{query.query}</span>"</>
                                ) : (
                                    <>No results for "<span class="ss__query">{query.query}</span>" found</>
                                )}
                            </h2> */}
                            <h2 class="ss__title collection-hero__title ss__title--has-results mt-14 mb-0 lg:mt-20">
                                {foundProducts && (
                                    <>Search results for "<span class="ss__query">{query.query}</span>"</>
                                )}
                            </h2>
                        </div>
                    </div>
                </div>
            ) : null}
            <div class={containerClass} data-grid-columns={gridColumns}>
                {foundProducts ? <ActionToolbar /> : null}
                <div class="ns-serp ns-d-flex ns-flex-column ns-flex-md-row"
                    data-nosto-element={type}>
                    {foundProducts && <Sidebar />}
                    <div
                        class="ns-products-grid-container ns-d-block ns-d-md-inline ns-border-box"
                        style={{ position: loading ? "relative" : "initial" }}>
                        { children({ loading, foundProducts }) }
                    </div>
                </div>
            </div>
        </>
    )
}

export function wrapContent(type, Component) {
    return () => (<ContentWrapper type={type}>{Component}</ContentWrapper>)
}